import * as React from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "store/state";
import { Content, PageHeader, Stage } from "../layout";

export const Debug: React.FunctionComponent = () => {
    const baaEnforced = useSelector(
        (state: ApplicationState) => state.tenant.tenant?.baaEnforced,
    );

    return (
        <Stage>
            <PageHeader title="Debug" />
            <Content>
                <div>{baaEnforced ? "1" : "0"}</div>
            </Content>
        </Stage>
    );
};
